import Vue from "vue";
import Vuex from "vuex";
import apply from "./modules/apply";
import user from "./modules/user";
import log from "./modules/log";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    apply,
    user,
    log
  },
});
